import Slider from './slider';
import MovieSlider from './movieSlider';
import Parallax from './parallax';
import HorizontalScroll from './horizontalScroll';
import PullDown from './pulldown';
import StickyBackground from './stickyBackground';
import Wave from './wave';
import Wow from './wow';
import FollowBnr from './followBnr';
import Clipboard from './clipboard';
// import SetHeight from './setHeight';
import 'lity/dist/lity.css';
import 'lity/dist/lity.js';
import '../css/style.scss';
import 'animate.css';
import 'particles.js';

Slider();
MovieSlider();
Parallax();
HorizontalScroll();
PullDown();
StickyBackground();
Wave();
Wow();
FollowBnr();
Clipboard();
// SetHeight();

particlesJS('particlesStar', {
  particles: {
    number: {
      value: 346,
      density: {
        enable: true,
        value_area: 800,
      },
    },
    color: {
      value: '#D6CB85',
    },
    shape: {
      type: 'circle',
      stroke: {
        width: 0,
      },
    },
    opacity: {
      value: 1,
      random: true,
      anim: {
        enable: true,
        speed: 1,
        opacity_min: 0,
        sync: false,
      },
    },
    size: {
      value: 1.5,
      random: true,
      anim: {
        enable: false,
        speed: 4,
        size_min: 0.3,
        sync: false,
      },
    },
    line_linked: {
      enable: false,
    },
    move: {
      enable: true,
      speed: 120,
      direction: 'none',
      random: true,
      straight: true,
      out_mode: 'out',
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 600,
      },
    },
  },
  interactivity: {
    detect_on: 'canvas',
    events: {
      onhover: {
        enable: false,
      },
      onclick: {
        enable: true,
        mode: 'push',
      },
      resize: true,
    },
    modes: {
      push: {
        particles_nb: 4,
      },
    },
  },
  retina_detect: true,
});
